import { render, staticRenderFns } from "./signup-error.vue?vue&type=template&id=1efde4d2&"
import script from "./signup-error.vue?vue&type=script&lang=js&"
export * from "./signup-error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports